
const ContactHero = () => {
  return (
    <section className="relative bg-gradient-to-r from-gray-900 to-gray-800 py-20">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20fire%20safety%20engineers%20working%20in%20modern%20office%20environment%20with%20fire%20protection%20equipment%20and%20technical%20drawings%20on%20desk%2C%20clean%20corporate%20setting%20with%20safety%20helmets%20and%20technical%20documentation%2C%20professional%20lighting&width=1200&height=600&seq=contact-hero&orientation=landscape')`
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <nav className="flex justify-center mb-8" aria-label="Breadcrumb">
            <ol className="flex items-center space-x-2 text-sm text-gray-300">
              <li>
                <a href="/" className="hover:text-white transition-colors">Home</a>
              </li>
              <li className="flex items-center">
                <i className="ri-arrow-right-s-line mx-2"></i>
                <span className="text-white">Contact</span>
              </li>
            </ol>
          </nav>
          
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Get in Touch with FlameGuardQA
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Have a question or need expert advice on fire protection systems?<br />
            We're here to help — whether you need a product quote, technical support, or fire safety consultation.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
